var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _vm.$route.params.userId ? _c("user-menu") : _vm._e(),
      _vm._v(" "),
      _vm.loginUser.userId == _vm.postData.userId ||
      _vm.hasAnyRole("ROLE_ADMIN", "ROLE_USER_ADMIN")
        ? _c(
            "div",
            { staticClass: "col-md-10 pt-3" },
            [
              _c(
                "form",
                {
                  staticClass: "p-2",
                  attrs: { autocomplete: "off" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.submit($event)
                    }
                  }
                },
                [
                  _c("h2", { staticClass: "subhead" }, [_vm._v("基本情報")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "userName" } }, [
                      _vm._v("氏名")
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.userName))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "userName" } }, [
                      _vm._v("現住所")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group form-inline" }, [
                      _c("label", { staticClass: "mr-1" }, [_vm._v("〒")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.currentPostalCode1,
                            expression: "currentPostalCode1"
                          }
                        ],
                        staticClass: "form-control form-control-sm",
                        staticStyle: { "max-width": "60px" },
                        attrs: { type: "number" },
                        domProps: { value: _vm.currentPostalCode1 },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.currentPostalCode1 = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "mr-1 ml-1" }, [_vm._v(" - ")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.currentPostalCode2,
                            expression: "currentPostalCode2"
                          }
                        ],
                        staticClass: "form-control form-control-sm",
                        staticStyle: { "max-width": "80px" },
                        attrs: { type: "number" },
                        domProps: { value: _vm.currentPostalCode2 },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.currentPostalCode2 = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.currentAddress,
                          expression: "postData.currentAddress"
                        }
                      ],
                      staticClass: "form-control col-sm-6",
                      attrs: {
                        type: "text",
                        placeholder: "例）東京都港区芝浦３丁目１４−１９"
                      },
                      domProps: { value: _vm.postData.currentAddress },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "currentAddress",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "userName" } }, [
                      _vm._v("住民票住所")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group form-inline" }, [
                      _c("label", { staticClass: "mr-1" }, [_vm._v("〒")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.residenceCardPostalCode1,
                            expression: "residenceCardPostalCode1"
                          }
                        ],
                        staticClass: "form-control form-control-sm",
                        staticStyle: { "max-width": "60px" },
                        attrs: { type: "number" },
                        domProps: { value: _vm.residenceCardPostalCode1 },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.residenceCardPostalCode1 = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "mr-1 ml-1" }, [_vm._v(" - ")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.residenceCardPostalCode2,
                            expression: "residenceCardPostalCode2"
                          }
                        ],
                        staticClass: "form-control form-control-sm",
                        staticStyle: { "max-width": "80px" },
                        attrs: { type: "number" },
                        domProps: { value: _vm.residenceCardPostalCode2 },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.residenceCardPostalCode2 = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.residenceCardAddress,
                          expression: "postData.residenceCardAddress"
                        }
                      ],
                      staticClass: "form-control col-sm-6",
                      attrs: {
                        type: "text",
                        placeholder: "例）東京都港区芝浦３丁目１４−１９"
                      },
                      domProps: { value: _vm.postData.residenceCardAddress },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "residenceCardAddress",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("携帯電話")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.tel1,
                          expression: "postData.tel1"
                        }
                      ],
                      staticClass: "form-control col-sm-6",
                      attrs: { type: "text", autocomplete: "nope" },
                      domProps: { value: _vm.postData.tel1 },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.postData, "tel1", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("携帯メールアドレス")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.mail,
                          expression: "postData.mail"
                        }
                      ],
                      staticClass: "form-control col-sm-6",
                      attrs: { type: "mail", autocomplete: "nope" },
                      domProps: { value: _vm.postData.mail },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.postData, "mail", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("緊急連絡先番号")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.tel2,
                          expression: "postData.tel2"
                        }
                      ],
                      staticClass: "form-control col-sm-6",
                      attrs: { type: "text", autocomplete: "nope" },
                      domProps: { value: _vm.postData.tel2 },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.postData, "tel2", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("緊急連絡先宛先")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.destination,
                          expression: "postData.destination"
                        }
                      ],
                      staticClass: "form-control col-sm-6",
                      attrs: { type: "text", autocomplete: "nope" },
                      domProps: { value: _vm.postData.destination },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "destination",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("h2", { staticClass: "subhead mt-5" }, [
                    _vm._v("交通手段")
                  ]),
                  _vm._v(" "),
                  _c("h3", { staticClass: "mt-4" }, [_vm._v("バス")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("バス会社名")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.busCompanyName,
                          expression: "postData.busCompanyName"
                        }
                      ],
                      staticClass: "form-control col-sm-6",
                      attrs: { type: "text", autocomplete: "nope" },
                      domProps: { value: _vm.postData.busCompanyName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "busCompanyName",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("自宅最寄停留所")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.busStart,
                          expression: "postData.busStart"
                        }
                      ],
                      staticClass: "form-control col-sm-6",
                      attrs: { type: "text", autocomplete: "nope" },
                      domProps: { value: _vm.postData.busStart },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "busStart",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("駅最寄停留所")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.busEnd,
                          expression: "postData.busEnd"
                        }
                      ],
                      staticClass: "form-control col-sm-6",
                      attrs: { type: "text", autocomplete: "nope" },
                      domProps: { value: _vm.postData.busEnd },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.postData, "busEnd", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group form-inline" }, [
                    _c("label", { staticClass: "mr-2" }, [_vm._v("片道")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.busOneWayExpense,
                          expression: "postData.busOneWayExpense"
                        }
                      ],
                      staticClass: "form-control mr-2",
                      attrs: { type: "number", autocomplete: "nope" },
                      domProps: { value: _vm.postData.busOneWayExpense },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "busOneWayExpense",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "mr-2" }, [
                      _vm._v("1ヶ月定期代")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.busMonthlyExpense,
                          expression: "postData.busMonthlyExpense"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "number", autocomplete: "nope" },
                      domProps: { value: _vm.postData.busMonthlyExpense },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "busMonthlyExpense",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("h3", { staticClass: "mt-4" }, [_vm._v("電車")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("自宅最寄駅")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.trainStartStation,
                          expression: "postData.trainStartStation"
                        }
                      ],
                      staticClass: "form-control col-sm-6",
                      attrs: { type: "text", autocomplete: "nope" },
                      domProps: { value: _vm.postData.trainStartStation },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "trainStartStation",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("会社最寄駅")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.trainEndStation,
                          expression: "postData.trainEndStation"
                        }
                      ],
                      staticClass: "form-control col-sm-6",
                      attrs: { type: "text", autocomplete: "nope" },
                      domProps: { value: _vm.postData.trainEndStation },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "trainEndStation",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("使用路線")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.trainRoute,
                          expression: "postData.trainRoute"
                        }
                      ],
                      staticClass: "form-control col-sm-6",
                      attrs: { type: "text", autocomplete: "nope" },
                      domProps: { value: _vm.postData.trainRoute },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "trainRoute",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group form-inline" }, [
                    _c("label", { staticClass: "mr-2" }, [_vm._v("片道")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.trainOneWayExpense,
                          expression: "postData.trainOneWayExpense"
                        }
                      ],
                      staticClass: "form-control mr-2",
                      attrs: { type: "number", autocomplete: "nope" },
                      domProps: { value: _vm.postData.trainOneWayExpense },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "trainOneWayExpense",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "mr-2" }, [
                      _vm._v("1ヶ月定期代")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.trainMonthlyExpense,
                          expression: "postData.trainMonthlyExpense"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "number", autocomplete: "nope" },
                      domProps: { value: _vm.postData.trainMonthlyExpense },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "trainMonthlyExpense",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("h2", { staticClass: "subhead mt-5" }, [
                    _vm._v("個人情報")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group form-inline" }, [
                    _c("label", { staticClass: "mr-2" }, [_vm._v("銀行名")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.bankName,
                          expression: "postData.bankName"
                        }
                      ],
                      staticClass: "form-control mr-2",
                      attrs: { type: "text", autocomplete: "nope" },
                      domProps: { value: _vm.postData.bankName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "bankName",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "mr-2" }, [_vm._v("銀行番号")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.bankNumber,
                          expression: "postData.bankNumber"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", autocomplete: "nope" },
                      domProps: { value: _vm.postData.bankNumber },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "bankNumber",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group form-inline" }, [
                    _c("label", { staticClass: "mr-2" }, [_vm._v("支店名")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.bankBranchName,
                          expression: "postData.bankBranchName"
                        }
                      ],
                      staticClass: "form-control mr-2",
                      attrs: { type: "text", autocomplete: "nope" },
                      domProps: { value: _vm.postData.bankBranchName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "bankBranchName",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "mr-2" }, [_vm._v("支店番号")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.bankBranchNumber,
                          expression: "postData.bankBranchNumber"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", autocomplete: "nope" },
                      domProps: { value: _vm.postData.bankBranchNumber },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "bankBranchNumber",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("預金タイプ")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.bankAccountType,
                          expression: "postData.bankAccountType"
                        }
                      ],
                      staticClass: "form-control col-sm-6",
                      attrs: { type: "text", autocomplete: "nope" },
                      domProps: { value: _vm.postData.bankAccountType },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "bankAccountType",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("口座番号（7ケタ）")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.bankAccountNumber,
                          expression: "postData.bankAccountNumber"
                        }
                      ],
                      staticClass: "form-control col-sm-6",
                      attrs: { type: "text", autocomplete: "nope" },
                      domProps: { value: _vm.postData.bankAccountNumber },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "bankAccountNumber",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("口座名義人（カナ）")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.postData.bankAccountHolder,
                          expression: "postData.bankAccountHolder"
                        }
                      ],
                      staticClass: "form-control col-sm-6",
                      attrs: { type: "text", autocomplete: "nope" },
                      domProps: { value: _vm.postData.bankAccountHolder },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.postData,
                            "bankAccountHolder",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm.loginUser.userId == _vm.postData.userId ||
                  _vm.hasAnyRole("ROLE_ADMIN")
                    ? _c("div", [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [_vm._v("基礎年金番号")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.postData.basicPensionNumber,
                                expression: "postData.basicPensionNumber"
                              }
                            ],
                            staticClass: "form-control col-sm-6",
                            attrs: { type: "text", autocomplete: "nope" },
                            domProps: {
                              value: _vm.postData.basicPensionNumber
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.postData,
                                  "basicPensionNumber",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [_vm._v("被保険者番号")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.postData.insuredNumber,
                                expression: "postData.insuredNumber"
                              }
                            ],
                            staticClass: "form-control col-sm-6",
                            attrs: { type: "text", autocomplete: "nope" },
                            domProps: { value: _vm.postData.insuredNumber },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.postData,
                                  "insuredNumber",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [_vm._v("個人番号")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.postData.personalNumber,
                                expression: "postData.personalNumber"
                              }
                            ],
                            staticClass: "form-control col-sm-6",
                            attrs: { type: "text", autocomplete: "nope" },
                            domProps: { value: _vm.postData.personalNumber },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.postData,
                                  "personalNumber",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.edit
                    ? _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("定期券")]),
                        _vm._v(" "),
                        _c("input", {
                          attrs: {
                            type: "file",
                            name: "file",
                            id: "newUploadFile"
                          },
                          on: { change: _vm.selectedFile }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$route.params.userId
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary m-2",
                          attrs: { type: "button" },
                          on: { click: _vm.goBack }
                        },
                        [_vm._v("戻る")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.edit
                    ? _c("input", {
                        staticClass: "btn btn-primary",
                        attrs: { type: "submit", value: "編集" }
                      })
                    : _c("input", {
                        staticClass: "btn btn-primary",
                        attrs: { type: "submit", value: "登録" }
                      })
                ]
              ),
              _vm._v(" "),
              _c("toast", { ref: "toast" }),
              _vm._v(" "),
              _vm.edit
                ? _c("div", { staticClass: "col-12 mt-3" }, [
                    _c("h2", { staticClass: "subhead mt-5" }, [
                      _vm._v("定期券写真")
                    ]),
                    _vm._v(" "),
                    _c("table", { staticClass: "table" }, [
                      _c("tr", [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("td", [
                          _vm.postData.imageUrl
                            ? _c("img", {
                                staticClass: "card-img-top icon",
                                attrs: { id: "byteImage" }
                              })
                            : _c("span", [_vm._v("なし")]),
                          _vm._v(" "),
                          _vm.postData.imageUrl
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-sm btn-outline-danger m-1",
                                  staticStyle: { "border-radius": "50px" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.deleteAttachment($event)
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-trash" }),
                                  _vm._v(
                                    "\n                  画像を削除\n              "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "form",
                            {
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.upload($event)
                                }
                              }
                            },
                            [
                              _c("input", {
                                attrs: {
                                  type: "file",
                                  name: "file",
                                  id: "uploadFile"
                                },
                                on: { change: _vm.selectedFile }
                              }),
                              _vm._v(" "),
                              _vm.uploadFile
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-info",
                                      staticStyle: { "border-radius": "50px" },
                                      attrs: { type: "submit" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-cloud-upload fa-1x",
                                        attrs: { "aria-hidden": "true" }
                                      }),
                                      _vm._v("アップロード\n                  ")
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      ])
                    ])
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("label", [_vm._v("現在の画像")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("label", [_vm._v("新しい画像")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-696cc162", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-696cc162","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/common/user/UserWorkRegistrationNewEdit.vue
// module id = 366
// module chunks = 0